import React, { useEffect } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { useQuery } from "@tanstack/react-query";
import MemberProfileCardMain from "./MemberProfileCardMain";
import { useLocation } from "react-router-dom";
import { getMember, getMemberById } from "../../services/memberServices";

const MemberProfileCard = () => {
  useEffect(() => {
    document.title = "Member Profile | Society of Aquaculture Professionals";
  }, []);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const memberId = params.get("id");

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["memberProfile", memberId],
    queryFn: () => getMemberById(memberId || undefined),
    enabled: !!memberId,
  });

  const member = data?.data?.member || null;
  const leadershipRole = data?.data?.leadershipRoles || null;

  console.log(member, "member");

  return (
    <>
      <Header />
      <MemberProfileCardMain member={member} leadershipRole={leadershipRole} />
      <Footer />
    </>
  );
};

export default MemberProfileCard;
